import { LoginPresentation } from './components/LoginPresentation';

export const LoginPage = (): JSX.Element => {
    return (
       <LoginPresentation/>
    )
};